module.exports = new __parcel__URL__("Charlie_Text-Thin.3ac72da7.woff").toString();